import { render, staticRenderFns } from "./SsoView.vue?vue&type=template&id=7a2a072f&scoped=true&"
import script from "./SsoView.vue?vue&type=script&lang=ts&"
export * from "./SsoView.vue?vue&type=script&lang=ts&"
import style0 from "./SsoView.vue?vue&type=style&index=0&id=7a2a072f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a2a072f",
  null
  
)

export default component.exports